import React, { useState } from "react";
import { useInView } from "../hooks/useInView";
import { trackEvent } from "../utils/analytics";

const tabs = [
  { id: "producenci", label: "Wszyscy producenci" },
  { id: "pneumatyka", label: "Pneumatyka" },
  { id: "czujniki", label: "Czujniki" },
  { id: "technika-napedowa", label: "Technika napędowa" },
  { id: "falowniki", label: "Falowniki" },
  { id: "bezpieczenstwo", label: "Bezpieczeństwo" },
  { id: "hydraulika", label: "Hydraulika" },
  { id: "sterowniki-wizualizacja", label: "Sterowniki i wizualizacja" },
];

const producenciGroup1 = [
  { nazwa: "FESTO", logo: "/pictures/producers_webp/festo.webp", scale: 0.9 },
  { nazwa: "OMRON", logo: "/pictures/producers_webp/omron.webp", scale: 0.9 },
  { nazwa: "IFM", logo: "/pictures/producers_webp/ifm.webp", scale: 1.5 },
  { nazwa: "SIEMENS", logo: "/pictures/producers_webp/siemens.webp", scale: 1 },
  { nazwa: "LENZE", logo: "/pictures/producers_webp/lenze.webp", scale: 0.9 },
  { nazwa: "SMC", logo: "/pictures/producers_webp/smc.webp", scale: 0.9 },
  { nazwa: "LEUZE", logo: "/pictures/producers_webp/leuze.webp", scale: 0.8 },
  { nazwa: "SICK", logo: "/pictures/producers_webp/sick.webp", scale: 0.85 },
  { nazwa: "AVENTICS", logo: "/pictures/producers_webp/aventics.webp" },
  { nazwa: "BALLUFF", logo: "/pictures/producers/balluff.png", scaleMobile: 0.9, scaleDesktop: 1.25 },
  { nazwa: "EATON", logo: "/pictures/producers/eaton.png", scale: 0.75 },
  {
    nazwa: "SCHNEIDER",
    logo: "/pictures/producers_webp/schneider.webp",
    scale: 1,
  },
  {
    nazwa: "ALLEN-BRADLEY",
    logo: "/pictures/producers_webp/allenbradley.webp",
    scaleMobile: 0.9,
    scaleDesktop: 1.25,
  },
  { nazwa: "BURKERT", logo: "/pictures/producers/burkert.png", scale: 1.25 },
  {
    nazwa: "PARKER",
    logo: "/pictures/producers_webp/parker.webp",
    scale: 1.25,
  },
  {
    nazwa: "PEPPERL+FUCHS",
    logo: "/pictures/producers_webp/pepperlfuchs.webp",
    scaleMobile: 0.9,
    scaleDesktop: 1.25,
  },
  {
    nazwa: "RECTUS",
    logo: "/pictures/producers_webp/rectus.webp",
    scale: 1.25,
  },
  { nazwa: "DANFOSS", logo: "/pictures/producers/danfoss.png" },
  {
    nazwa: "METAL WORK",
    logo: "/pictures/producers/metalwork.png",
    scale: 1.25,
  },
  { nazwa: "TURCK", logo: "/pictures/producers/turck.png", scale: 1.25 },
  { nazwa: "BANNER", logo: "/pictures/producers/banner.png" },
  { nazwa: "REXROTH", logo: "/pictures/producers/rexroth.png" },
  { nazwa: "ABB", logo: "/pictures/producers_webp/abb.webp", scale: 0.9 },
];

const producenciGroup2 = [
  {
    nazwa: "Schmersal",
    logo: "/pictures/producers_webp/schmersal.webp",
    scale: 1,
  },
  { nazwa: "Harting", logo: "/pictures/producers/harting.png", scale: 1.15 },
  {
    nazwa: "Bernstein",
    logo: "/pictures/producers_webp/bernstein.webp",
    scale: 1,
  },
  {
    nazwa: "Kobold",
    logo: "/pictures/producers_webp/kobold.webp",
    scale: 1.15,
  },
  { nazwa: "Asco", logo: "/pictures/producers_webp/asco.webp", scale: 0.8 },
  {
    nazwa: "Bonfiglioli",
    logo: "/pictures/producers/bonfiglioli.png",
    scale: 1,
  },
  {
    nazwa: "Yaskawa",
    logo: "/pictures/producers_webp/yaskawa.webp",
    scale: 0.8,
  },
  { nazwa: "Koganei", logo: "/pictures/producers/koganei.png", scale: 1 },
  { nazwa: "Fatek", logo: "/pictures/producers_webp/fatek.webp", scale: 0.8 },
  { nazwa: "Sels", logo: "/pictures/producers/sels.png", scale: 1.25 },
  { nazwa: "Sem Polska", logo: "/pictures/producers/sempolska.png", scale: 1 },
  {
    nazwa: "Phoenix Contact",
    logo: "/pictures/producers/phoenix.png",
    scale: 0.75,
  },
  {
    nazwa: "Weidmuller",
    logo: "/pictures/producers_webp/weidmuller.webp",
    scale: 1,
  },
  {
    nazwa: "Panasonic",
    logo: "/pictures/producers_webp/panasonic.webp",
    scale: 0.75,
  },
  {
    nazwa: "Lappkabel",
    logo: "/pictures/producers_webp/lappkabel.webp",
    scale: 1,
  },
  {
    nazwa: "Finder",
    logo: "/pictures/producers_webp/finder.webp",
    scale: 0.75,
  },
  { nazwa: "Omec Motors", logo: "/pictures/producers/omec.png", scale: 1.5 },
  { nazwa: "SEW", logo: "/pictures/producers_webp/sew.webp", scale: 1 },
  {
    nazwa: "Camozzi",
    logo: "/pictures/producers_webp/camozzi.webp",
    scale: 1.25,
  },
  {
    nazwa: "Rittal",
    logo: "/pictures/producers_webp/rittal.webp",
    scale: 1.25,
  },
  {
    nazwa: "Chiaravalli",
    logo: "/pictures/producers/chiaravalli.png",
    scale: 1.25,
  },
  { nazwa: "Besel", logo: "/pictures/producers/besel.png", scale: 1.5 },
  { nazwa: "Sanyu", logo: "/pictures/producers_webp/sanyu.webp", scale: 0.75 },
  {
    nazwa: "Ls Electric",
    logo: "/pictures/producers/lselectric.png",
    scale: 0.9,
  },
  { nazwa: "Relpol", logo: "/pictures/producers/relpol.png", scale: 0.75 },
  {
    nazwa: "Datalogic",
    logo: "/pictures/producers_webp/datalogic.webp",
    scale: 1,
  },
  { nazwa: "Nord", logo: "/pictures/producers/nord.png", scale: 1.25 },
  {
    nazwa: "Norgren",
    logo: "/pictures/producers_webp/norgren.webp",
    scale: 0.75,
  },
  { nazwa: "Mean Well", logo: "/pictures/producers/meanwell.png", scale: 0.75 },
  { nazwa: "Pilz", logo: "/pictures/producers/pilz.png", scale: 1 },
  { nazwa: "Wika", logo: "/pictures/producers/wika.png", scale: 0.75 },
  {
    nazwa: "Ultrafilter",
    logo: "/pictures/producers/ultrafilter.png",
    scale: 0.75,
  },
  {
    nazwa: "Donaldson",
    logo: "/pictures/producers/donaldson.png",
    scale: 0.75,
  },
  {
    nazwa: "Ponar",
    logo: "/pictures/producers_webp/ponar.webp",
    scale: 0.75,
  },
  {
    nazwa: "Atos",
    logo: "/pictures/producers_webp/atos.webp",
    scale: 0.75,
  },
  {
    nazwa: "Hydac",
    logo: "/pictures/producers_webp/hydac.webp",
    scale: 0.75,
  },
  {
    nazwa: "Vickers",
    logo: "/pictures/producers_webp/vickers.webp",
    scale: 0.75,
  },
];

const allProducers = [...producenciGroup1, ...producenciGroup2];

// Funkcja pomocnicza do obliczania skali obrazka
const getImageScale = (producer) => {
  return producer.scale || 1;
};

// Funkcja do generowania responsywnych stylów skali
const getResponsiveScaleStyle = (producer) => {
  if (producer.scaleMobile && producer.scaleDesktop) {
    return {
      '--scale-mobile': producer.scaleMobile,
      '--scale-desktop': producer.scaleDesktop,
    };
  }
  return {};
};

const producers = {
  producenci: allProducers,
  pneumatyka: [
    "FESTO",
    "SMC",
    "AVENTICS",
    "PARKER",
    "RECTUS",
    "METAL WORK",
    "CAMOZZI",
    "NORGREN",
  ],
  czujniki: [
    "Datalogic",
    "SICK",
    "Omron",
    "IFM",
    "Bernstein",
    "Leuze",
    "Kobold",
    "Panasonic",
    "Turck",
    "Balluff",
    "Sels",
    "Pepperl+fuchs",
    "Banner",
  ],
  falowniki: [
    "Siemens",
    "Lenze",
    "Abb",
    "Schneider",
    "Danfoss",
    "Sanyu",
    "Yaskawa",
    "Ls electric",
  ],
  "technika-napedowa": [
    "Lenze",
    "Schneider",
    "Parker",
    "Rexroth",
    "Abb",
    "Bonfiglioli",
    "Nord",
    "Sem Polska",
    "Omec motors",
    "Allen-Bradley",
    "Yaskawa",
    "Besel",
    "SEW",
    "Chiaravalli",
  ],
  bezpieczenstwo: [
    "Omron",
    "Allen-Bradley",
    "SICK",
    "Schmersal",
    "pilz",
    "Schneider",
    "Leuze",
  ],
  hydraulika: [
    "Parker",
    "Rexroth",
    "Danfoss",
    "Vickers",
    "Atos",
    "Hydac",
    "Ponar",
  ],
  "sterowniki-wizualizacja": [
    "Siemens",
    "Omron",
    "Schneider",
    "Allen-Bradley",
    "Fatek",
  ],
};

const producersCombined = Object.keys(producers).reduce((acc, curr) => {
  acc[curr] = [];

  if (curr === "producenci") {
    acc[curr] = allProducers;
    return acc;
  }

  producers[curr].forEach((name) => {
    const element = allProducers.find(
      (producer) =>
        typeof name === "string" &&
        producer.nazwa?.toLowerCase() === name?.toLowerCase()
    );

    if (element) {
      acc[curr].push(element);
    }
  });

  return acc;
}, {});

const Producers = () => {
  const [activeTab, setActiveTab] = useState("producenci");
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const handleTabClick = (tabId, tabLabel, platform = "desktop") => {
    setActiveTab(tabId);
    trackEvent("kategoria_producenci", {
      category: "Producenci",
      label: tabLabel,
      tab_id: tabId,
      platform: platform === "desktop" ? "komputer" : "telefon",
    });
  };

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div ref={ref} className="mb-16">
          <h2
            className={`text-sm md:text-base lg:text-lg font-light font-sans text-special1-500 uppercase transition-all duration-700 tracking-wider text-[#0F1523] ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Producenci
          </h2>
          <p
            className={`text-3xl md:text-4xl lg:text-5xl xl:text-6xl text-special1-500 max-w-3xl font-heading transition-all duration-700 delay-200 leading-tight ${
              inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            Dostarczamy sprawdzone rozwiązania od liderów branży przemysłowej
          </p>
        </div>

        {/* Desktop Tabs */}
        <div className="hidden lg:flex flex-nowrap gap-2 mb-12">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id, tab.label, "desktop")}
              className={`flex-grow px-1 py-2 rounded-lg font-light transition-all duration-300 ${
                activeTab === tab.id ? "tab-active" : "tab-inactive"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {/* Mobile Tabs - Horizontal Scroll */}
        <div className="lg:hidden mb-12">
          <div className="flex overflow-x-auto gap-2 pb-4 scrollbar-hide">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id, tab.label, "mobile")}
                className={`px-4 py-2 rounded-lg font-medium whitespace-nowrap transition-all duration-300 ${
                  activeTab === tab.id ? "tab-active" : "tab-inactive"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Producers Grid */}
        <div
          className={`transition-all duration-500 ${
            inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {activeTab === "producenci" ? (
            <div className="space-y-8">
              {/* Wiodący producenci */}
              <div className="pb-20">
                <h3 className="text-lg font-medium text-special1-500 uppercase mb-4 tracking-wider">
                  Wiodący producenci
                </h3>
                <div className="flex flex-wrap justify-between gap-y-4">
                  {producenciGroup1.map((producer, index) => (
                    <div
                      key={`group1-${producer.nazwa}-${index}`}
                      className="w-[calc(50%-8px)] sm:w-[calc(33.333%-8px)] md:w-[calc(25%-8px)] lg:w-[calc(20%-8px)] xl:w-[calc(16.666%-8px)] p-2 sm:p-3 md:p-4 lg:p-5 rounded-sm text-center transition-all duration-300 flex items-center justify-center min-h-[50px] sm:min-h-[55px] md:min-h-[60px]"
                    >
                      <img
                        src={producer.logo}
                        alt={producer.nazwa}
                        className={`max-w-full max-h-[28px] sm:max-h-[32px] md:max-h-[36px] lg:max-h-[40px] w-auto h-auto object-contain ${
                          producer.scaleMobile && producer.scaleDesktop 
                            ? 'scale-[var(--scale-mobile)] md:scale-[var(--scale-desktop)]' 
                            : ''
                        }`}
                        style={{
                          ...getResponsiveScaleStyle(producer),
                          ...(!(producer.scaleMobile && producer.scaleDesktop) && {
                            transform: `scale(${getImageScale(producer)})`,
                          }),
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>

              {/* Pozostali producenci */}
              <div>
                <h3 className="text-lg font-medium text-special1-500 uppercase mb-4 tracking-wider">
                  Pozostali producenci
                </h3>
                <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-7 xl:grid-cols-8 gap-1 sm:gap-2 md:gap-3">
                  {producenciGroup2.map((producer, index) => (
                    <div
                      key={`group2-${producer.nazwa}-${index}`}
                      className="p-1 sm:p-1 md:p-1 py-0 rounded-sm text-center transition-all duration-300 flex items-center justify-center min-h-[40px] sm:min-h-[45px] md:min-h-[50px]"
                    >
                       <img
                         src={producer.logo}
                         alt={producer.nazwa}
                         className={`max-w-full max-h-[24px] sm:max-h-[28px] md:max-h-[32px] w-auto h-auto object-contain ${
                           producer.scaleMobile && producer.scaleDesktop 
                             ? 'scale-[var(--scale-mobile)] md:scale-[var(--scale-desktop)]' 
                             : ''
                         }`}
                         style={{
                           ...getResponsiveScaleStyle(producer),
                           ...(!(producer.scaleMobile && producer.scaleDesktop) && {
                             transform: `scale(${getImageScale(producer)})`,
                           }),
                         }}
                       />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-wrap justify-between gap-y-4">
              {producersCombined[activeTab]?.map((producer, index) => (
                <div
                  key={`${activeTab}-${producer.nazwa}-${index}`}
                  className="py-2 px-3 sm:p-2 rounded-sm text-center transition-all duration-300 flex items-center justify-center min-h-[45px] sm:min-h-[50px]"
                >
                  <img
                    src={producer.logo}
                    alt={producer.nazwa}
                    className={`max-w-full max-h-[24px] sm:max-h-[28px] md:max-h-[32px] w-auto h-auto object-contain ${
                      producer.scaleMobile && producer.scaleDesktop 
                        ? 'scale-[var(--scale-mobile)] md:scale-[var(--scale-desktop)]' 
                        : ''
                    }`}
                    style={{
                      ...getResponsiveScaleStyle(producer),
                      ...(!(producer.scaleMobile && producer.scaleDesktop) && {
                        transform: `scale(${getImageScale(producer)})`,
                      }),
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Producers;
